import script from "./TextareaSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextareaSimple.vue?vue&type=script&setup=true&lang=ts"

import "./TextareaSimple.vue?vue&type=style&index=0&id=0e6628d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e6628d4"]])

export default __exports__